import React from 'react'
import Container from 'react-bootstrap/Container'
import MainNav from './MainNav'

const Layout = ({ children }) => (
  <>
    <MainNav />
    <Container className='my-3'>
      {children}
    </Container>
  </>
)

export default Layout
